export default [
  {
    path: "/index",
    name: "index",
    component: () => import("@/pages/home/index.vue"),
    meta: {
      title: "首页",
      keep: true, // 是否需要缓存页面
    },
  },
];
